<template>
  <DefaultLayout
    :class="computedClass"
    :style="`
      --preview-header-color: #0530a4;
      --main-color: #2962f9;
      --main-color-2: #2962F9;
      --hover-color: #264eb1;
      --hover-color-2: #264eb1;
      --bg-color-substrate: #f8f9fb;
      --bg-color-substrate-2: #E1EAFD;
      --bg-color-substrate-3: #F3F5FC;
    `"
    class="health-template"
  >
    <template #above-content>
      <TheAboutUs v-if="isHealthHome && !isErrorPage" />
    </template>

    <slot />
  </DefaultLayout>
</template>

<script lang="ts">
  import DefaultLayout from './default.vue';
  import TheAboutUs from '~/components/AboutUs/TheAboutUs.vue';
  import { useThemeColorHead } from '~/domains/head/technical/services/useThemeColorHead';

  export default defineNuxtComponent({
    name: 'HealthLayout',

    components: {
      DefaultLayout,
      TheAboutUs,
    },

    setup() {
      useThemeColorHead('#2962f9');

      return {
        route: useRoute(),
        serviceError: useError(),
      };
    },

    computed: {
      isErrorPage(): boolean {
        return Boolean(this.serviceError);
      },
      isHealthHome(): boolean {
        return this.route.name === 'health-home';
      },
      computedClass(): Record<string, boolean> {
        return {
          'health-service-container': this.route.name === 'health-services',
        };
      },
    },
  });
</script>

<style lang="scss">
  .health-template {
    background-color: #f3f5fc;

    .lh-large-article-card__wrapper::before {
      top: 0;
      height: 100%;
    }
  }
</style>
